import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["response", "download", "groupComposite"]

  handleChange() {
    window.open(this.responseTarget.value || this.downloadTarget.value, '_blank')
    this.responseTarget.value = ''
    this.downloadTarget.value = ''
  }

  toggleAllResponseRates(event) {
    const checked = event.currentTarget.checked;
    document.querySelectorAll('.response-rate-checkbox').forEach((checkbox) => {
      checkbox.checked = checked
    });
  }

  generateResponseRatePdf(event) {
    event.preventDefault();

    const selectedIds = Array.from(document.querySelectorAll('.response-rate-checkbox'))
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);

    if (selectedIds.length === 0) {
      alert('Please select at least one response rate.');
      return;
    }

    const baseUrl = event.currentTarget.dataset.url;
    const url = new URL(baseUrl, window.location.origin);
    selectedIds.forEach(id => url.searchParams.append('selected_ids[]', id));

    window.open(url.toString(), '_blank');
  }
}
